(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["watt-prod-collapsible-msg"] && !Shopify.designMode) return;
  try {
    /**
 * 全局第三方代码区域
 * */
document.addEventListener('DOMContentLoaded', function() {
  // impact 跨站点追踪的需求
  try {
    const imRef = new URLSearchParams(window.location.search).get('im_ref');
    if (!imRef) return;

    function processGlobalMenu() {
      const widget = document.querySelector('watt-global-menu-widget');
      if (!widget || !widget.shadowRoot) return false;

      const links = widget.shadowRoot.querySelectorAll('.watt-global-menu-dropdown__link');
      links.forEach(link => {
        const url = new URL(link.href);
        if (!url.searchParams.has('im_ref')) {
          url.searchParams.set('im_ref', imRef);
          link.href = url.toString();
        }
      });
      return true;
    }

    if (!processGlobalMenu()) {
      const observer = new MutationObserver(() => {
        if (processGlobalMenu()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 3000);
    }
  } catch (err) {
    // 捕获异常，防止整个脚本崩溃
    console.error('Global Menu Script Error:', err);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watt-sale-counter"] && !Shopify.designMode) return;
  try {
    (function () {
  function initWattSalesCounter(counters) {
    var numberEl = counters.getElementById('#watt-sales-number');
    if (!numberEl) return;

    var base = Number(numberEl.getAttribute('data-base-number')) || 0;
    var min = Number(numberEl.getAttribute('data-min-increase')) || 0;
    var max = Number(numberEl.getAttribute('data-max-increase')) || 0;

    var STORAGE_KEY = 'watt_sales_counter_value';
    var DATE_KEY = 'watt_sales_counter_date';

    var today = new Date().toISOString().split('T')[0];
    var savedDate = window.localStorage.getItem(DATE_KEY);
    var savedValue = Number(window.localStorage.getItem(STORAGE_KEY));

    if (!savedValue) {
      savedValue = base;
      window.localStorage.setItem(STORAGE_KEY, String(savedValue));
      window.localStorage.setItem(DATE_KEY, today);
    }

    if (savedDate !== today) {
      var randomIncrease = Math.floor(Math.random() * (max - min + 1)) + min;
      savedValue += randomIncrease;
      window.localStorage.setItem(STORAGE_KEY, String(savedValue));
      window.localStorage.setItem(DATE_KEY, today);
    }

    animateNumber(numberEl, savedValue);
  }

  function animateNumber(el, finalValue) {
    var current = 0;
    var duration = 800;
    var step = finalValue / (duration / 16);

    function update() {
      current += step;
      if (current >= finalValue) {
        current = finalValue;
      } else {
        window.requestAnimationFrame(update);
      }
      el.textContent = Math.floor(current).toLocaleString();
    }

    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var counters = document.querySelectorAll('#watt-sales-counter');
    counters.forEach(function () {
      initWattSalesCounter(counters);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
